// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jX11","badges":"styles_badges__3Ijc4"};